import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons' // Importe o ícone específico

export const HomeTopBar = () =>{

   return(
      
      <div>


          
           <nav class="navbar navbar-expand-lg" style={{backgroundColor:'#DCDCDC'}}>
            <div class="container-fluid">
               <a class="navbar-brand" href="#">SuperLider</a>
               <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span class="navbar-toggler-icon"></span>
               </button>
               <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item">
                     <a class="nav-link active" aria-current="page" href="#">Home</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" href="#">Nossos Canais</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" href="https://superlideronline.com.br/sistema" target='_blank'>App</a>
                  </li>
                  <li class="nav-item dropdown">
                     <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Segmentos
                     </a>
                     <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#">Representante Sthil</a></li>
                        <li><a class="dropdown-item" href="#">Supermercado</a></li>
                        <li><a class="dropdown-item" href="#">Mat.Construção</a></li>
                     </ul>
                  </li>
                  </ul>
                  <form class="d-flex" role="search">
                  <input class="form-control me-2" type="search" placeholder="Pesquise por:" aria-label="Search" />
                  <button class="btn btn-outline-success" type="submit">Pesquisar</button>
                  </form>
               </div>
            </div>
            </nav>


      </div>

   )
}